import { render, staticRenderFns } from "./Zuhe.vue?vue&type=template&id=1f1b23db&"
import script from "./Zuhe.vue?vue&type=script&lang=js&"
export * from "./Zuhe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports